import React from 'react';

import searchCaseInsensitive from '../../../utils/searchCaseInsensitive';
import searchInArray from '../../../utils/searchInArray';
import searchNumbers from '../../../utils/searchNumbers';
import CellNumbersTableCell from '../../../partials/CellNumbersTableCell/CellNumbersTableCell';
import TableNameCell from '../../../partials/tableNameCell/TableNameCell';
import StatusCell from '../../../partials/statusCell/StatusCell';
import pickOptionsForStatusCell from '../../../partials/statusCell/actions/pickOptionsForStatusCell';
import createTableFilterSelectOptions from '../../../utils/createTableFilterSelectOptions';
import STATUS_BOX_OPTIONS from '../../../consts/statusBoxOptions';
import LockUserTableCell from '../../../partials/lockUserTableCell/LockUserTableCell';
import formatDate from '../../../utils/formatDate';
import TableActionButtons from './TableActionButtons';
import Optional from '../../../utils/optional';
import { isUndefined } from '../../../utils/isDefined';
import customTableColumnSort from '../../../utils/customTableColumnSort';
import can from '../../../utils/can';
import createSubject from '../../../utils/createSubject';
import { FILTER_CELL_STYLE_RIGHT_ALIGNED } from '../../../consts/tableOptions';
import { translate } from '../../../i18n/I18nProvider';
import CopyToClipbaordTooltip from '../../../partials/copyToClipbaordTooltip/CopyToClipbaordTooltip';

export default function tableColumns({
  clientId,
  lockUserAction,
  filtersOptions = {},
  settings,
  users
}) {
  const columns = [
    {
      render: rowData => (
        <TableActionButtons
          data={rowData}
          clientId={Optional(clientId).or(rowData.client_id)}
        />
      ),
      // cellStyle: styles.actionCell,
      disableClick: true,
      sorting: false,
      width: '40px'
    },
    {
      title: 'TABLE.NAME',
      render: rowData => (
        <TableNameCell
          data={[rowData]}
          from="telephonyUsers"
          clientId={clientId}
        />
      ),
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.name, term);
      },
      field: 'name',
      customSort: (a, b) => customTableColumnSort(a, b, 'name'),
      width: '150px'
    },
    {
      title: 'USER.CUSTOM_ID',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.loginId, term);
      },
      field: 'loginId',
      hidden: true
    },
    {
      title: 'USER.DOMAIN_NAME',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.username, term);
      },
      field: 'username',
      width: '100px'
    },
    {
      title: 'TABLE.EMAIL',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.email, term);
      },
      field: 'email',
      width: '200px'
    },
    {
      title: 'TABLE.DEPARTMENT',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.department, term);
      },
      field: 'department',
      lookup: filtersOptions.department,
      width: '120px'
    },
    {
      title: 'USER.LICENSE_TYPE',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.licenceType, term);
      },
      field: 'licenceType',
      lookup: filtersOptions.licenceType
    },
    {
      title: 'TABLE.ADMIN_ROLE',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.adminRoleId, term);
      },
      field: 'adminRoleId',
      lookup: filtersOptions.adminRoleId,
      width: '110px'
    },
    {
      title: 'TABLE.PRIMARY_LINE',
      field: 'primaryNumber',
      customFilterAndSearch: (term, rowData) => {
        return searchNumbers(rowData.primaryNumber, term);
      },
      render: rowData => (
        <CopyToClipbaordTooltip
          value={rowData.primaryNumber}
          isPhoneNumber={true}
        >
          {rowData.primaryNumber}
        </CopyToClipbaordTooltip>
      ),
      width: '140px',
      align: 'right',
      filterCellStyle: FILTER_CELL_STYLE_RIGHT_ALIGNED
    },
    {
      title: 'TABLE.PRIMARY_TYPE',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.primaryNumberType, term);
      },
      field: 'primaryNumberType',
      width: '140px',
      hidden: true
    },
    {
      title: 'TABLE.SECONDARY_LINE',
      field: 'secondaryNumber',
      customFilterAndSearch: (term, rowData) => {
        return searchNumbers(rowData.secondaryNumber, term);
      },
      render: rowData => (
        <CopyToClipbaordTooltip
          value={rowData.secondaryNumber}
          isPhoneNumber={true}
        >
          {rowData.secondaryNumber}
        </CopyToClipbaordTooltip>
      ),
      width: '140px',
      align: 'right',
      filterCellStyle: FILTER_CELL_STYLE_RIGHT_ALIGNED
    },
    {
      title: 'TABLE.SECONDARY_TYPE',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.secondaryNumberType, term);
      },
      field: 'secondaryNumberType',
      width: '140px',
      hidden: true
    },
    {
      title: 'ALIASES',
      customSort: (a, b) => sortFirstArrayElement(a.aliases, b.aliases),
      customFilterAndSearch: (term, rowData) =>
        searchInArray({
          array: rowData.aliases,
          term,
          isValueNumber: true
        }),
      render: rowData => rowData.aliases.join(','),
      width: '140px',
      align: 'right',
      field: 'aliases',
      filterCellStyle: FILTER_CELL_STYLE_RIGHT_ALIGNED
    },
    {
      title: 'REQUEST_NEW_USER.COST_CENTER',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.costCentre, term);
      },
      field: 'costCentre',
      hidden: true
    },
    {
      title: 'LANGUAGE',
      customFilterAndSearch: (term, rowData) => {
        return searchCaseInsensitive(rowData.language, term);
      },
      field: 'language',
      width: '100px',
      hidden: true
    },
    {
      title: 'TABLE.MOBILES',
      customSort: (a, b) => sortFirstArrayElement(a.mobiles, b.mobiles),
      customFilterAndSearch: (term, rowData) =>
        searchInArray({
          array: rowData.mobileNumbers,
          term,
          isValueNumber: true
        }),
      render: rowData => <CellNumbersTableCell data={rowData.mobileNumbers} />,
      width: '120px',
      align: 'right',
      field: 'mobileNumbers',
      filterCellStyle: FILTER_CELL_STYLE_RIGHT_ALIGNED
    },
    {
      title: 'SOFTPHONE',
      field: 'softphoneEnabled',
      render: rowData => (
        <StatusCell
          {...pickOptionsForStatusCell(
            STATUS_BOX_OPTIONS.TRUE_FALSE,
            rowData.softphoneEnabled
          )}
        />
      ),
      lookup: {
        ...createTableFilterSelectOptions(STATUS_BOX_OPTIONS.TRUE_FALSE)
      }
    },
    {
      title: 'MOBILE_APP',
      field: 'mobileApp',
      render: rowData => (
        <StatusCell
          {...pickOptionsForStatusCell(
            STATUS_BOX_OPTIONS.TRUE_FALSE,
            rowData.mobileApp
          )}
        />
      ),
      lookup: {
        ...createTableFilterSelectOptions(STATUS_BOX_OPTIONS.TRUE_FALSE)
      }
    },
    {
      title: 'SIP_DESKTOP_PHONE',
      field: 'sip_phones',
      hidden: true
    },
    {
      title: 'SIP_PHONE_3RD',
      field: 'third_party_phone_type',
      lookup: {
        ...createTableFilterSelectOptions(STATUS_BOX_OPTIONS.PHONE_TYPES)
      },
      hidden: true
    },
    {
      title: 'IPAD_SUPPORT',
      field: 'iPadEnabled',
      render: rowData => (
        <StatusCell
          {...pickOptionsForStatusCell(
            STATUS_BOX_OPTIONS.TRUE_FALSE,
            rowData.iPadEnabled
          )}
        />
      ),
      lookup: {
        ...createTableFilterSelectOptions(STATUS_BOX_OPTIONS.TRUE_FALSE)
      },
      hidden: true
    },
    {
      title: 'USER.LOCATION',
      field: 'location',
      hidden: true
    },
    {
      title: `${translate('USER.ACCES_TO_SELFCARE')} ${Optional(
        settings?.title
      ).or('selfacre')}`,
      untranslatedTitle: true,
      field: 'locked',
      render: rowData => (
        <LockUserTableCell data={rowData} lockUserAction={lockUserAction} />
      ),
      sorting: false,
      lookup: {
        ...createTableFilterSelectOptions(STATUS_BOX_OPTIONS.LOCK)
      }
    },
    {
      title: 'CREATED_AT',
      render: rowData => formatDate(rowData.created_at),
      field: 'created_at',
      hidden: true
    },
    {
      title: 'UPDATED_AT',
      render: rowData => formatDate(rowData.updated_at),
      field: 'updated_at',
      hidden: true
    },
    {
      title: Optional(users[0]?.field1?.name).or(`${translate('FIELD')} 1`),
      render: rowData => rowData.field1?.value,
      field: 'field1.value',
      customSort: (a, b) => customTableColumnSort(a, b, 'field1.value'),
      hidden: true,
      untranslatedTitle: true
    },
    {
      title: Optional(users[0]?.field2?.name).or(`${translate('FIELD')} 2`),
      render: rowData => rowData.field2?.value,
      field: 'field2.value',
      customSort: (a, b) => customTableColumnSort(a, b, 'field2.value'),
      hidden: true,
      untranslatedTitle: true
    },
    {
      title: Optional(users[0]?.field3?.name).or(`${translate('FIELD')} 3`),
      render: rowData => rowData.field3?.value,
      field: 'field3.value',
      customSort: (a, b) => customTableColumnSort(a, b, 'field3.value'),
      hidden: true,
      untranslatedTitle: true
    },
    {
      title: Optional(users[0]?.field4?.name).or(`${translate('FIELD')} 4`),
      render: rowData => rowData.field4?.value,
      field: 'field4.value',
      customSort: (a, b) => customTableColumnSort(a, b, 'field4.value'),
      hidden: true,
      untranslatedTitle: true
    },
    {
      title: Optional(users[0]?.field5?.name).or(`${translate('FIELD')} 5`),
      render: rowData => rowData.field5?.value,
      field: 'field5.value',
      customSort: (a, b) => customTableColumnSort(a, b, 'field5.value'),
      hidden: true,
      untranslatedTitle: true
    },
    {
      title: Optional(users[0]?.field6?.name).or(`${translate('FIELD')} 6`),
      render: rowData => rowData.field6?.value,
      field: 'field6.value',
      customSort: (a, b) => customTableColumnSort(a, b, 'field6.value'),
      hidden: true,
      untranslatedTitle: true
    }
  ];

  let mappedColumns = [...columns];

  if (can('manage', createSubject('User', { client_id: Number(clientId) }))) {
    mappedColumns = [
      ...mappedColumns,
      {
        title: 'ID',
        field: 'id',
        hidden: true
      }
    ];
  }

  return mappedColumns.map((column, i) => {
    return { ...column, id: i };
  });
}

function sortFirstArrayElement(a = [], b = []) {
  const firstElement = a[0];
  const secondElement = b[0];
  if (isUndefined(firstElement)) return -1;
  if (isUndefined(secondElement)) return 1;
  if (firstElement === secondElement) return 0;
  return firstElement < secondElement ? -1 : 1;
}
